import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '@/lib/react-query';
import { InvoiceControllerGetInvoicesV1Params, getSMPBackendAPIAdmin } from '@/proxy';
import { toInvoice } from '@/services';

function getInvoices(params: InvoiceControllerGetInvoicesV1Params) {
  return getSMPBackendAPIAdmin().invoiceControllerGetInvoicesV1(params);
}

export function useInvoices(params: InvoiceControllerGetInvoicesV1Params) {
  return useQuery({
    queryKey: queryKeys.billing.invoices(params),
    queryFn: () => getInvoices(params),
    select: (data) => data.map(toInvoice),
    enabled: !!params,
  });
}
